import { Box, CircularProgress, Typography } from '@mui/material'

import { useTexts } from '../hooks/useTexts'

import { CardContainer } from './CardContainer'

export function LoadingCard() {
  const texts = useTexts()

  return (
    <CardContainer>
      <Box pb={1} width={48} height={48}>
        <CircularProgress size={32} />
      </Box>

      <Typography variant="subtitle4">{texts.card.loading.title}</Typography>
    </CardContainer>
  )
}
